import React, {Fragment} from 'react';
import PropTypes from "prop-types";
import {useMediaQuery} from "beautiful-react-hooks";

import Text from "./SummaryQuestionText";

const QuestionDetails = (props) => {
    const isMobile = useMediaQuery('(max-width: 599px)');

    return (
        <div className={`results__item ${!!Object.keys(props.answer).length ? 'answered': ''}`}>
            <div className="row">
                <div className="col-2">
                    <div className="results__number">{props.question.code.split('Q')[1]}</div>
                </div>
                <div className="col-10">
                    <div className="results__details">
                        <strong>{props.question.text.replace('…', '… ')}</strong>
                        <p className="results__answers">
                            <Text text={props.question.answers[0].text} condition={props.answer.first} />
                            {!isMobile && <Fragment>&nbsp;/&nbsp;</Fragment>}
                            <Text text={props.question.answers[1].text} condition={!!Object.keys(props.answer).length && !props.answer.first} />
                        </p>
                        <div className="results__graph">
                            <small>
                                <Text text={`${props.question.answers[0].percent}%`} condition={props.answer.first} />
                            </small>
                            <div className="results__graph__line" data-percent={props.question.answers[0].percent}>
                                <span className={(!!Object.keys(props.answer).length && !props.answer.first) ? 'yellow' : ''} />
                                <span className={props.answer.first ? 'yellow' : ''}
                                      style={{width: `${props.question.answers[0].percent}%`}}
                                />
                            </div>
                            <small>
                                <Text text={`${props.question.answers[1].percent}%`} condition={!!Object.keys(props.answer).length && !props.answer.first} />
                            </small>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default QuestionDetails;

QuestionDetails.defaultProps = {
    question: {},
    answer: {},
};

QuestionDetails.propTypes = {
    question: PropTypes.object,
    answer: PropTypes.object,
};


// WEBPACK FOOTER //
// ./sources/js/components/Summary/SummaryQuestionDetails.js